import { inject, Pipe, PipeTransform } from '@angular/core';
import { CucmDnReportRow } from '../migrations-cisco/migrations-cisco-directory-number-report/migrations-cisco-directory-numbers-report.component';
import { SuggestedProduct } from '../../shared/models/generated/ziroModels';
import { ZiroIcons } from '../../shared/models/ziro-icons.enum';
import { TranslateService } from '@ngx-translate/core';
import { UiSuggestedCallingProduct } from './migrations.service';

interface SuggestedProductInfo {
  value: string;
  icon?: ZiroIcons;
}

@Pipe({
  name: 'suggestedCallingProduct',
})
export class MigrationsSuggestedCallingProductPipe implements PipeTransform {
  private _translateService = inject(TranslateService);

  private readonly SUGGESTED_CALLING_PRODUCT_ROW_MAP = new Map<SuggestedProduct, SuggestedProductInfo>([
    [
      SuggestedProduct.SHARED_CALLING,
      {
        value: 'tkey;migrations.cisco.suggested_calling_products.shared_calling.label',
        icon: ZiroIcons.SHARED_CALLING,
      },
    ],
    [
      SuggestedProduct.BUNDLED_MINUTES,
      {
        value: 'tkey;migrations.cisco.suggested_calling_products.bundled_minutes.label',
        icon: ZiroIcons.BUNDLED_MINUTES,
      },
    ],
    [
      SuggestedProduct.PER_MINUTE,
      {
        value: 'tkey;migrations.cisco.suggested_calling_products.per_minute.label',
        icon: ZiroIcons.PER_MINUTE,
      },
    ],
  ]);

  transform(value: UiSuggestedCallingProduct, row: CucmDnReportRow): string {
    const productMap = this.SUGGESTED_CALLING_PRODUCT_ROW_MAP;

    if (!value || !row) {
      return '';
    }

    const diffInDays = row?.diffInDays ?? 0;

    const getDynamicIcon = (baseIcon: string): string => {
      if (diffInDays && diffInDays < 30) {
        return `<i class="${ZiroIcons.UNDEFINED} text-warning text-secondary"></i>`;
      }
      return `<i class="${baseIcon} text-secondary"></i>`;
    };

    switch (value) {
      case UiSuggestedCallingProduct.SHARED_CALLING: {
        const productInfo = productMap.get(SuggestedProduct.SHARED_CALLING);
        return `
          <span class="alert alert-inline alert-info">
            ${getDynamicIcon(productInfo.icon)}
            <span>${this._translateService.instant(productInfo.value)}</span>
          </span>
        `;
      }
      case UiSuggestedCallingProduct.PER_MINUTE: {
        const productInfo = productMap.get(SuggestedProduct.PER_MINUTE);
        return `
          <span class="alert alert-inline alert-info">
            <i class="${productInfo.icon} text-secondary"></i>
            <span>${this._translateService.instant(productInfo.value)}</span>
          </span>
        `;
      }
      case UiSuggestedCallingProduct.BUNDLED_MINUTES: {
        const productInfo = productMap.get(SuggestedProduct.BUNDLED_MINUTES);
        return `
          <span class="alert alert-inline alert-info">
            <i class="${productInfo.icon} text-secondary"></i>
            <span>${this._translateService.instant(productInfo.value)}</span>
          </span>
        `;
      }
      default:
        return '';
    }
  }
}
